import { useUtils } from './useUtils';

export const useConditionHelpers = () => useUtils().conditionHelpers;
